import React from 'react';
import { TableLoader } from './common/table-loader';
import { PageHeaderLoader } from './common/page-header-loader';
import { TabsLoader } from './common/tabs-loader';

export const BillingProfileDetailsPageLoader = () => {
  return (
    <div className="pl-8" data-testid="billing-profile-details-page-loader">
      <PageHeaderLoader />
      <TabsLoader tabsCount={7} />
      <br />
      <TableLoader />
    </div>
  );
};
